import React from 'react';
import { Laptop, Smartphone, ArrowRight } from 'lucide-react';

interface MobileUnsupportedProps {
  title?: string;
  description?: string;
}

const MobileUnsupported: React.FC<MobileUnsupportedProps> = ({
  title = "Desktop Experience Recommended",
  description = "The diagram editor is optimized for desktop browsers. Please open beaUX on a desktop computer for the full interactive experience.",
}) => {
  return (
    <div className="w-full h-full min-h-[60vh] flex flex-col items-center justify-center p-6 text-center bg-gradient-to-b from-slate-50/20 to-indigo-50/20 dark:from-slate-900/20 dark:to-indigo-950/10 rounded-lg border border-indigo-100/20 dark:border-indigo-900/20">
      <div className="flex items-center justify-center mb-6 relative">
        <div className="absolute w-full h-32 top-0 left-0 flex items-center justify-center pointer-events-none overflow-hidden opacity-20">
          {/* Decorative background elements */}
          <div className="absolute w-24 h-24 rounded-full bg-indigo-200 dark:bg-indigo-800 blur-2xl transform -translate-x-1/3"></div>
          <div className="absolute w-24 h-24 rounded-full bg-purple-200 dark:bg-purple-800 blur-2xl transform translate-x-1/3"></div>
        </div>
        
        <div className="flex items-center">
          <div className="text-slate-400 dark:text-slate-500 p-2 rounded-full bg-slate-100 dark:bg-slate-800">
            <Smartphone className="w-8 h-8" />
          </div>
          
          <ArrowRight className="w-6 h-6 mx-4 text-slate-400 dark:text-slate-500" />
          
          <div className="text-indigo-500 dark:text-indigo-400 p-2 rounded-full bg-indigo-50 dark:bg-indigo-900/30">
            <Laptop className="w-10 h-10" />
          </div>
        </div>
      </div>
      
      <h2 className="text-2xl font-bold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-indigo-500">
        {title}
      </h2>
      
      <p className="text-base text-muted-foreground max-w-md mb-6">
        {description}
      </p>
      
      <div className="flex flex-col gap-4 w-full max-w-xs">
        <div className="p-4 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 text-left shadow-sm">
          <h3 className="text-sm font-medium text-slate-800 dark:text-slate-200 mb-1">What works on mobile:</h3>
          <ul className="text-xs text-slate-600 dark:text-slate-400 list-disc list-inside space-y-1">
            <li>Viewing your saved diagrams</li>
            <li>Navigating between sections</li>
            <li>Learning about beaUX features</li>
          </ul>
        </div>
        
        <div className="p-4 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 text-left shadow-sm">
          <h3 className="text-sm font-medium text-slate-800 dark:text-slate-200 mb-1">Best experienced on desktop:</h3>
          <ul className="text-xs text-slate-600 dark:text-slate-400 list-disc list-inside space-y-1">
            <li>Interactive diagram editor</li>
            <li>Component creation and linking</li>
            <li>Mermaid import and visualization</li>
            <li>Codebase exploration tools</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MobileUnsupported;